{
    "RunondayMonthLabel": "Ausführung am Tag (Monat):",
    "RunondayWeekLabel": "Ausführung am Tag (Woche):",
    "RunondaysLabel": "Bericht ausführen an Tagen:",
    "RunbetweenhoursStartLabel": "Zwischen den Stunden laufen:",
    "RunbetweenhoursEndLabel": "Und:",
    "RunbetweenhoursNote": "(inklusive der gesamten Endstunde)",
    "RunatminuteHourLabel": "Laufen bei Minute (Stunde):",
    "RunatminuteHourNote": "Nach jeder Stunde (ungefähr)",
    "RunondateLabel": "Bericht ausführen am Datum:",
    "RunattimeLabel": "Ausführungszeit (ungefähr):",
    "TimeOptions_SectionHeader": "Zeitoptionen",
    "NAME": "TimeOptions"
}